// extracted by mini-css-extract-plugin
export default {"disabledLink":"link_disabledLink__+X6iJ"};